import { QUEST_GOAL, type Progress } from "../lib/progress";
import { formatInt, formatPace, formatPercent } from "../lib/format";

const PACE_LABEL: Record<Progress["paceStatus"], string> = {
  empty: "NO PACE YET",
  behind: "BEHIND",
  on_pace: "ON PACE",
  ahead: "AHEAD",
  complete: "COMPLETE",
};

export function ProgressHUD({ progress }: { progress: Progress }) {
  const label = `Quest progress: ${progress.count} of ${QUEST_GOAL} live apps, ${formatPercent(progress.percent)}, ${progress.daysLeft} days remaining, need ${formatPace(progress.needPerDay)} ships per day, streak ${progress.streak}, shipped today ${progress.shippedToday}.`;

  return (
    <div className="hud" role="region" aria-label={label}>
      <div className="viewfinder" aria-hidden="true">
        <span className="vf tl" />
        <span className="vf tr" />
        <span className="vf bl" />
        <span className="vf br" />
      </div>

      <div className="hud-track">
        <div className="stat stat-count">
          <span className="stat-label">LIVE</span>
          <span className="stat-value">
            {formatInt(progress.count)}
            <span className="stat-slash">/{formatInt(QUEST_GOAL)}</span>
          </span>
        </div>

        <div className="stat">
          <span className="stat-label">FILLED</span>
          <span className="stat-value">{formatPercent(progress.percent)}</span>
        </div>

        <div className="stat stat-bar" aria-hidden="true">
          <span className="stat-label">WALL</span>
          <span className="bar">
            <span
              className="bar-fill"
              style={{ width: `${progress.percent}%` }}
            />
          </span>
        </div>

        <div className="stat">
          <span className="stat-label">DAYS LEFT</span>
          <span className="stat-value">{formatInt(progress.daysLeft)}</span>
        </div>

        <div className="stat">
          <span className="stat-label">NEED / DAY</span>
          <span className="stat-value">{formatPace(progress.needPerDay)}</span>
        </div>

        <div className="stat">
          <span className="stat-label">PACE</span>
          <span className="stat-value">
            {progress.actualPerDay === null ? "—" : formatPace(progress.actualPerDay)}
            <span className="stat-flag">{PACE_LABEL[progress.paceStatus]}</span>
          </span>
        </div>

        <div className="stat">
          <span className="stat-label">STREAK</span>
          <span className="stat-value">{formatInt(progress.streak)}</span>
        </div>

        <div className="stat">
          <span className="stat-label">SHIPPED TODAY</span>
          <span className="stat-value">{formatInt(progress.shippedToday)}</span>
        </div>
      </div>
    </div>
  );
}
